import React, { useState, useEffect } from "react";
import YhInput from "../../../../../ui/YhInput";
import YhButton from "../../../../../ui/YhButton";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import {
  getLeaveDetail,
  saveLeaveDetails,
  updateLeaveInfo,
} from "../StepperService";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import {
  getFinalBodyStructure,
  handleValidation,
  initialState,
  validateInput,
} from "./ValidatorLeave";

const _ = require("lodash");

interface CustomProps {
  nextStep?: () => void | undefined;
  userId: String;
  backStep?: () => void | undefined;
  fromSettingOrLogout?: any;
  registerStepActions?: (actions: { submit: () => void | Promise<void> }) => void;
  hideFooterButtons?: boolean;
}

let clonedObject = {};

const LeaveDetails = (props: CustomProps) => {
  const [apiResponse, setApiResponse] = useState(false);
  const [leaveDetail, setLeaveDetail] = useState<any>(initialState({}));
  const [dataFlag, setDataFlag] = React.useState<Number>(0);

  const handleOnChangeInputField = (event: React.ChangeEvent<any>) => {
    const name: any = event.target.name;
    const value: any = event.target.value;
    const isGoForward: any = validateInput(name, value);
    if (!isGoForward) return;
    setLeaveDetail({
      ...leaveDetail,
      [name]: { value: value, error: "" },
    });
    // debugger;
    if (
      leaveDetail.earned_leave.error ===
        "Should be less than or equal to total leave" &&
      leaveDetail.sick_leave.error ===
        "Should be less than or equal to total leave" &&
      leaveDetail.casual_leave.error ===
        "Should be less than or equal to total leave"
    ) {
      setLeaveDetail({
        ...leaveDetail,
        earned_leave: {
          value:
            name === "earned_leave" ? value : leaveDetail.earned_leave.value,
          error: "",
        },
        sick_leave: {
          value: name === "sick_leave" ? value : leaveDetail.sick_leave.value,
          error: "",
        },
        casual_leave: {
          value:
            name === "casual_leave" ? value : leaveDetail.casual_leave.value,
          error: "",
        },
      });
    }
  };

  useEffect(() => {
    init();
  }, []);

  const handleBackBtn = () => {
    props.backStep?.();
  };

  const init = async () => {
    if (props.userId) {
      try {
        setApiResponse(true);
        const response = await getLeaveDetail(props.userId);
        customErrorHandler(response);
        console.log(response, "props.userId");

        setLeaveDetail(initialState(response.data));
        setDataFlag(response.success ?? 0);
        clonedObject = _.cloneDeep(response.data);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        {
          error.message !== "Data not found" &&
            openErrorNotification(
              isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
            );
        }
      }
    }
  };
  console.log(props.userId, "props.userId");
  // submit method
  const submitForm = async () => {
    const validatedObject: any = handleValidation(leaveDetail);
    if (
      validatedObject?.earned_leave.error ||
      validatedObject.sick_leave.error ||
      validatedObject.casual_leave.error ||
      validatedObject.total_leave.error
    ) {
      setLeaveDetail({ ...validatedObject });
      return;
    }
    if (props.userId && _.isEqual(clonedObject, leaveDetail) && dataFlag) {
      props.nextStep?.();
    } else if (props.userId && dataFlag) {
      try {
        setApiResponse(true);
        const body: any = { ...leaveDetail };
        console.log(body, "props.userId");

        body.id = { value: body.id.value, error: "" };
        const response = await updateLeaveInfo(getFinalBodyStructure(body));
        if (response?.success) {
          setLeaveDetail(response.data);
          openSuccessNotification(response?.message);
          props.nextStep?.();
        } else {
          customErrorHandler(response);
        }
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    } else {
      try {
        setApiResponse(true);
        const body = { ...leaveDetail };
        body.userId = { value: props.userId, error: "" };
        const response = await saveLeaveDetails(getFinalBodyStructure(body));
        if (response?.success) {
          setLeaveDetail(response.data);
          openSuccessNotification(response?.message);
          props.nextStep?.();
        } else {
          customErrorHandler(response);
        }
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };

  useEffect(() => {
    props.registerStepActions?.({ submit: submitForm });
  });

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const inputs = document.getElementsByTagName("input");
      const currentIndex = Array.from(inputs).indexOf(
        event.target as HTMLInputElement
      );
      const nextIndex = currentIndex + 1;

      if (nextIndex < inputs.length) {
        inputs[nextIndex].focus();
      } else {
        // If the last input field is reached, trigger the submitForm function
        submitForm();
      }
    }
  };

  return (
    <div className="w-full">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-[#111827]">Leave Details</h2>
        <p className="mt-1 text-sm text-[#6B7280]">
          Update your leave information for the platform
        </p>
      </div>

      <div className="mb-6 mt-5">
        <h3 className="text-base font-semibold text-[#111827]">Leave Details</h3>
        <p className="mt-1 text-sm text-[#6B7280]">Define total leave assigned</p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <YhInput
          label="Total Leaves"
          value={leaveDetail.total_leave.value || ""}
          onChange={handleOnChangeInputField}
          name="total_leave"
          error={leaveDetail?.total_leave?.error}
          onKeyPress={handleKeyPress}
        />

        <YhInput
          label="Earned Leave"
          value={leaveDetail.earned_leave.value || ""}
          onChange={handleOnChangeInputField}
          name="earned_leave"
          error={leaveDetail?.earned_leave?.error}
          onKeyPress={handleKeyPress}
        />

        <YhInput
          label="Sick Leave"
          value={leaveDetail.sick_leave.value || ""}
          onChange={handleOnChangeInputField}
          name="sick_leave"
          error={leaveDetail?.sick_leave?.error}
          onKeyPress={handleKeyPress}
        />

        <YhInput
          label="Causal Leave"
          value={leaveDetail.casual_leave.value || ""}
          onChange={handleOnChangeInputField}
          name="casual_leave"
          error={leaveDetail?.casual_leave?.error}
          onKeyPress={handleKeyPress}
        />

        <div className="mt-2 flex flex-wrap gap-3 lg:col-span-2">
          {props.hideFooterButtons ? null : (
            <>
              <YhButton variant="secondary" onClick={handleBackBtn}>
                Back
              </YhButton>
              <YhButton variant="primary" onClick={submitForm}>
                Save & Continue
              </YhButton>
            </>
          )}
        </div>
      </div>

      {apiResponse && <CustomLoader apiResponse={false} />}
    </div>
  );
};

export default LeaveDetails;
